const ENV = 'uat';
// const ENV = 'prod';

const CLIENT = 'india';
// const CLIENT = 'nepal';

const API_CONFIG = {
    india: {
        auto: {
            uat: 'https://autouatapi.acrossassist.in/api/Auto/',
            prod: 'https://autoapi.acrossassist.com/api/Auto/',
        },
        endorsementData: {
            uat: 'https://ins.acrossassist.in/api/Endorsement/',
            prod: 'https://ins.acrossassist.in/api/Endorsement/',
        },
        financeVendor: {
            uat: 'https://tmagadgetapi.acrossassist.in/api/FinanceVendor/',
            prod: 'https://gadgetapi.acrossassist.com/api/FinanceVendor/',
        },
        techfinance: {
            uat: 'https://financeuatapi.acrossassist.in/api/Auto',
            prod: 'https://financeportalapi.acrossassist.com/api/Auto',
        },
    },

    nepal: {
        auto: {
            uat: 'https://crmuatapi.ldassist.co/api/FinanceVendor/',
            prod: 'https://crmuatapi.ldassist.co/api/FinanceVendor/',
        },
        endorsementData: {
            uat: 'https://ins.acrossassist.in/api/Endorsement/',
            prod: 'https://ins.acrossassist.in/api/Endorsement/',
        },
        financeVendor: {
            uat: 'https://crmuatapi.ldassist.co/api/FinanceVendor/',
            prod: 'https://crmuatapi.ldassist.co/api/FinanceVendor/',
        },
        techfinance: {
            uat: 'https://crmuatapi.ldassist.co/api/FinanceVendor/',
            prod: 'https://crmuatapi.ldassist.co/api/FinanceVendor/',
        },
    },
};

const config = API_CONFIG[CLIENT];

export const baseURLAuto = config.auto[ENV];
export const baseURLFinanceVendor = config.financeVendor[ENV];
export const baseURLTechFinance = config.techfinance[ENV];
export const baseURLEndorsementData =
    config.endorsementData?.[ENV] || '';

export const isIndia = CLIENT === 'india';
export const isNepal = CLIENT === 'nepal';

export const addInvoicingRemarkInGadgetRemark = true;

export default {
    baseURLAuto,
    baseURLFinanceVendor,
    baseURLTechFinance,
    baseURLEndorsementData,
    isIndia,
    isNepal,
    addInvoicingRemarkInGadgetRemark,
};